module.exports = __webpack_public_path__ + "img/xfl.72a84ef2.svg";